import { render, staticRenderFns } from "./AlertDelete.vue?vue&type=template&id=12b16a67"
import script from "./AlertDelete.vue?vue&type=script&lang=js"
export * from "./AlertDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports